import { attachSlidingPagination } from "../../../../shared/pagination";

const TABLE_ROOT_SELECTOR = '[x-data="UniqueListenersBreakdownTable()"]';

document.addEventListener('turbo:load', initUniqueListenersPagination);
document.addEventListener('DOMContentLoaded', initUniqueListenersPagination);
document.addEventListener('prefix:uniqueListenersBreakdown:pagination', initUniqueListenersPagination);

function getStore() {
  return (window.Alpine && Alpine.store) ? Alpine.store('uniqueListenersBreakdown') : null;
}

function initUniqueListenersPagination() {
  try {
    if (!document.querySelector(TABLE_ROOT_SELECTOR)) return;

    const store = getStore();
    if (!store) return;
    attachSlidingPagination({
      getState: () => ({
        current_page: store.page,
        total_pages: store.total_pages,
      }),
      setPage: (p) => {
        if (p === store.page) return;
        store.page = p;
        if (typeof store.reload === 'function') store.reload();
      },
      containerId: 'pagination',
      prevId: 'prevPageBtn',
      nextId: 'nextPageBtn',
      windowSize: 3,
    });
  } catch (_) {}
}
